module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Insured":"Insured","Spouse":"Spouse"},"si":{"Insured":"ජීවිත රක්ෂිතයා","Spouse":"කලත්‍රයා"},"ta":{"Insured":"பிரதான வாழ்க்கை","Spouse":"வாழ்க்கைத்துணை"}}')
  delete Component.options._Ctor
}
